<template>
  <base-dialog
    ref="dialog"
    :title="'支払済ステータス解除'"
    :message="'チェック済データの支払済ステータスを解除します。'"
    :cancel-text="$t('message.modal_cancel_btn')"
    :submit-text="'解除'"
    :loading="loading"
    max-width="650"
    @submit="submit()"
  />
</template>

<script>
export default {
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    open() {
      this.stopload()
      this.$refs.dialog.open()
    },
    close() {
      this.stopload()
      this.$refs.dialog.close()
    },
    startload() {
      this.loading = true
    },
    stopload() {
      this.loading = false
    },
    submit() {
      this.startload()
      this.$emit('submit')
    },
  },
}
</script>
